import storyTasksTemplate from './storyTasks.html';

function StoryTasksController(
  $scope,
  $translate,
  Task,
  tasksService,
  taskModalService,
  confirmationDialog,
  toastWrapperService,
  $log,
  layoutService,
  storyDrawerService,
  analyticsService,
  _,
  featureFlag
) {
  $scope.tasksv2enabled = false;
  featureFlag.isEnabled('tasksv2').then((enabled) => {
    $scope.tasksv2enabled = enabled;
  });

  function createSuccess(newTask) {
    if (newTask && newTask.id) {
      $scope.tasks.unshift(newTask);

      toastWrapperService.createToast(
        $translate.instant('TASK_CREATED'),
        'success'
      );
      analyticsService.trackEvent(
        'Task management (task drawer)',
        'Created task'
      );
    }
  }

  function updateSuccess(updatedTask) {
    if (updatedTask) {
      const match = _.find($scope.tasks, (task) => task.id === updatedTask.id);
      const index = $scope.tasks.indexOf(match);

      angular.extend($scope.tasks[index], updatedTask);

      toastWrapperService.createToast(
        $translate.instant('TASK_UPDATED'),
        'success'
      );
      analyticsService.trackEvent(
        'Task management (tasks panel)',
        'Updated task'
      );
    }
  }

  function deleteConfirmedAction(task) {
    task.delete().then(
      (response) => {
        _.remove($scope.tasks, task);

        $log.log('task deleted successfully: ', response);
        toastWrapperService.createToast(
          $translate.instant('TASK_DELETED'),
          'success'
        );
        analyticsService.trackEvent(
          'Task management (tasks panel)',
          'Deleted task'
        );
      },
      (response) => {
        $log.error(response);
      }
    );
  }

  $scope.layout = layoutService;

  $scope.$watch('story.id', (newV) => {
    if (newV) {
      tasksService.getTasksByStoryId($scope.story.id).then(
        (tasksData) => {
          $scope.tasks = [];
          if (tasksData) {
            tasksData
              .slice()
              .reverse()
              .forEach((task) => {
                $scope.tasks.push(new Task(task));
              });
          }
        },
        (tasksResponse) => {
          $log.error(tasksResponse);
          toastWrapperService.createToast(
            $translate.instant('ERROR_LOADING_TASKS'),
            'danger'
          );
        }
      );
    }
  });

  $scope.saveTask = (taskToSave, mode = 'create') => {
    const task = taskToSave || {};
    if (!task.storyID) {
      task.storyID = $scope.story.id;
    }

    const success = mode === 'create' ? createSuccess : updateSuccess;

    taskModalService.saveTask(success, task);
  };

  $scope.deleteTask = (task) => {
    confirmationDialog.confirm('DELETE_TASK_Q', () => {
      deleteConfirmedAction(task);
    });
  };

  $scope.dismiss = () => {
    storyDrawerService.dismiss();
  };
}

function directive() {
  return {
    restrict: 'E',
    scope: {
      story: '=',
      task: '='
    },
    template: storyTasksTemplate,
    controller: [
      '$scope',
      '$translate',
      'Task',
      'tasksService',
      'taskModalService',
      'confirmationDialog',
      'toastWrapperService',
      '$log',
      'layoutService',
      'storyDrawerService',
      'analyticsService',
      '_',
      'featureFlag',
      StoryTasksController
    ]
  };
}

export default function (ngModule) {
  ngModule.directive('storyTasks', directive);
}
